module.exports = __webpack_public_path__ + "img/g1.d235d9cd.png";